import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

/* Global Declerations */
//Directives
import './directives'
// plugins
import './plugins'
/* Filters */
import './filters'
/* Components */
import churchIcon  from '@/components/churchappIcons'
import slideUpPop from '@/components/slideUpPop'
import mGoalViewItem from './components/m-goal-view-item.vue'
import mNewGoalPop from './components/m-new-goal-pop.vue'
import mInnerPageHeader from './views/m-inner-page-header.vue'
import successPop from './components/successPop.vue'
import deleteConfirmationPop from './components/deleteConfirmationPop.vue'
import mSearchUser from './components/m-search-user.vue'
import mGoalTaskList from './components/m-goal-task-list.vue'
import mAssignedUserList from './components/m-assigned-user-list.vue'
import meetingContentLoader from './components/meetingContentLoader.vue'
import mAssignedUsersPop from './components/mAssignedUsersPop.vue'
import mMeetingTaskItem from './views/m-meeting-task-item.vue'
import overallTaskCircleChart from './components/overallTaskCircleChart.vue'
import anayticsTaskGroup from './views/anayticsTaskGroup.vue'
import goalSlider from './components/goalList.vue'
import adminMeetingViewAssignments from './views/adminMeetingViewAssignments.vue'
import pdfViwer from './components/pdfViwer.vue'
import taskListPop from './components/taskListPop.vue'
import meetingAttendance from './views/meetingAttendance.vue'
import datePicker from './components/datePicker.vue'
import searchField from './components/searchField.vue'
import searchPopList from './components/searchPopList.vue'
import modal from './components/modal.vue'
import slideLeftListReveal from './components/slideLeftListReveal.vue'
import meetingAttendanceDashboardChart from './views/meetingAttendanceDashboardChart.vue'
import sacramentAttendance from './views/sacramentAttendance.vue'
import formGroup from './components/formGroup.vue'
import AddSacramentAttendance from './views/AddSacramentAttendance.vue'
import sacramentAttendanceListPop from './components/sacramentAttendanceListPop.vue'
import newUserPop from './components/newUserPop.vue'
import mdropdown from './components/mdropdown.vue'
import changepassword from './components/changePassword.vue'

Vue.component('church-icon', churchIcon)
Vue.component('slide-up', slideUpPop)
Vue.component('m-slide-up', slideUpPop)
Vue.component('m-goal-view-item', mGoalViewItem)
Vue.component('m-new-goal-pop', mNewGoalPop)
Vue.component('m-inner-page-header', mInnerPageHeader)
Vue.component('m-success-pop', successPop)
Vue.component('m-delete-confirmation-pop', deleteConfirmationPop)
Vue.component('m-search-user', mSearchUser)
Vue.component('m-goal-task-list', mGoalTaskList)
Vue.component('m-assigned-user-list', mAssignedUserList)
Vue.component('m-meeting-content-loader', meetingContentLoader)
Vue.component('m-assigned-users-pop', mAssignedUsersPop)
Vue.component('m-meeting-task-item', mMeetingTaskItem)
Vue.component('m-overall-task-circle-chart', overallTaskCircleChart)
Vue.component('m-anaytics-task-group', anayticsTaskGroup)
Vue.component('m-goal-slider', goalSlider)
Vue.component('m-admin-meeting-view-assignments', adminMeetingViewAssignments)
Vue.component('m-pdf-viewer', pdfViwer)
Vue.component('m-task-list-pop', taskListPop)
Vue.component('m-meeting-attendance', meetingAttendance)
Vue.component('m-date-picker', datePicker)
Vue.component('m-search-field', searchField)
Vue.component('m-search-pop-list', searchPopList)
Vue.component('m-modal', modal)
Vue.component('m-slide-left-list-reveal', slideLeftListReveal)
Vue.component('m-meeting-attendance-dashboard-chart', meetingAttendanceDashboardChart)
Vue.component('m-sacrament-attendance', sacramentAttendance)
Vue.component('m-form-group', formGroup)
Vue.component('m-add-sacrament-attendance', AddSacramentAttendance)
Vue.component('m-sacrament-attendance-list-pop', sacramentAttendanceListPop)
Vue.component('m-new-user-pop', newUserPop)
Vue.component('m-dropdown', mdropdown)
Vue.component('m-change-password', changepassword)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


/* remove console in production */
console.log(process.env.NODE_ENV)

if(process.env.NODE_ENV != 'development') {
  console.log = () => {}
}

